module.exports = __webpack_public_path__ + "f4850afaecf8666f409cd7531301cf6f.pdf";